import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight, Calendar } from "lucide-react";
import { api } from "../lib/api";

const InsuranceThankYouPage = () => {
  const [params] = useSearchParams();
  const referenceNumber = params.get("ref") || "";
  const [schedulingUrl, setSchedulingUrl] = useState(null);

  useEffect(() => {
    api.get("/config/public")
      .then((r) => setSchedulingUrl(r.data?.schedulingUrl || null))
      .catch(() => setSchedulingUrl(null));
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Minimal header */}
      <header className="border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-6 h-[70px] flex items-center gap-3">
          <div className="w-9 h-9 bg-[#0B2343] flex items-center justify-center">
            <span className="text-[#C89B3C] font-bold text-lg font-serif">N</span>
          </div>
          <div>
            <p className="font-serif text-sm font-bold text-[#0B2343] leading-tight">
              Noble Insurance
            </p>
            <p className="text-[10px] uppercase tracking-wider text-slate-400">
              Consultation Received
            </p>
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-2xl text-center">
          <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-8">
            <CheckCircle2 className="text-emerald-600" size={32} />
          </div>

          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#0B2343] leading-tight mb-4">
            Thank You
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed mb-2">
            Your consultation request has been received.
          </p>
          <p className="text-base text-slate-500 leading-relaxed mb-8">
            A licensed Noble Insurance advisor will review your information and contact
            you using your preferred method.
          </p>

          {referenceNumber && (
            <div className="bg-slate-50 border-l-4 border-[#C89B3C] p-5 mb-8 inline-block text-left">
              <p className="text-xs uppercase tracking-wider text-slate-500 mb-1">
                Your consultation reference number
              </p>
              <p
                data-testid="thankyou-reference"
                className="font-mono text-2xl text-[#0B2343] font-bold"
              >
                {referenceNumber}
              </p>
            </div>
          )}

          <div className="bg-amber-50 border border-amber-200 p-4 text-sm text-amber-900 mb-10 text-left">
            <strong>Important:</strong> Please do not cancel or replace any existing
            insurance coverage until new coverage has been formally approved and is in
            force.
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/insurance"
              data-testid="thankyou-return-btn"
              className="border-2 border-[#0B2343] text-[#0B2343] hover:bg-[#0B2343] hover:text-white px-8 py-4 font-medium transition-colors inline-flex items-center justify-center gap-2"
            >
              Return to Noble Insurance
            </Link>
            {schedulingUrl && (
              <a
                href={schedulingUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="thankyou-schedule-btn"
                className="bg-[#C89B3C] text-white hover:bg-[#a8852f] px-8 py-4 font-medium transition-colors inline-flex items-center justify-center gap-2"
              >
                <Calendar size={18} /> Schedule My Consultation
              </a>
            )}
          </div>

          <p className="mt-12 text-xs text-slate-400">
            Noble Insurance · Noble Strategies Consulting · 786-519-7988
          </p>
        </div>
      </main>
    </div>
  );
};

export default InsuranceThankYouPage;
